import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import { useDataModel } from '@thd-nucleus/data-sources';
import { CtaSection } from '../common/CtaSection';
import { buildSamLink } from '../../utils/home-services-cta-utils';
import { SCHEDULE_A_MEASURE_CONTACT_NUMBER } from '../../utils/home-services-cta-constants';
import { dataModel } from './dataModel';

const { string, bool, func, object: objectType } = proptypes;

const ScheduleAMeasureCta = ({
  itemId, onClick, hideContactInfo, target, enableNewTab, isFooter, productData
}) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('schedule-a-measure.ready'); }, []);

  // Only fetch data if productData is not provided as a prop
  const { data: fetchedData } = useDataModel('product', {
    skip: !itemId || !!productData, // Skip if no itemId or if productData is provided
    ssr: true,
    variables: {
      itemId
    }
  });
  const data = productData || fetchedData;

  if (!itemId) {
    return null;
  }

  const {
    product: {
      identifiers: {
        specialOrderSku,
        storeSkuNumber
      } = {}
    } = {}
  } = data || {};

  return (
    <CtaSection
      buttonText="Schedule a Measure"
      contactNumber={SCHEDULE_A_MEASURE_CONTACT_NUMBER}
      buttonLink={buildSamLink(specialOrderSku || storeSkuNumber)}
      isFooter={isFooter}
      hideContactInfo={hideContactInfo}
      openContentInDrawer={!enableNewTab}
      onClick={onClick}
      target={target}
      dataComponent="ScheduleAMeasureCta"
    />
  );
};

ScheduleAMeasureCta.displayName = 'ScheduleAMeasureCta';

ScheduleAMeasureCta.dataModel = dataModel;

ScheduleAMeasureCta.propTypes = {
  enableNewTab: bool,
  hideContactInfo: bool,
  isFooter: bool,
  itemId: string.isRequired,
  onClick: func,
  target: string,
  productData: objectType
};

ScheduleAMeasureCta.defaultProps = {
  enableNewTab: false,
  hideContactInfo: false,
  isFooter: false,
  onClick: () => {},
  target: '_blank',
  productData: null
};

export { ScheduleAMeasureCta };